import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  suppliersGridLabel: {
    defaultMessage: 'Suppliers',
    id: 'YYf76V',
    description: 'Suppliers page header',
  },
  addSupplierButton: {
    defaultMessage: 'Add Supplier',
    id: 'P1Zr2m',
    description: 'Add Supplier Button',
  },
  importButton: {
    defaultMessage: 'Import',
    id: 'yrpFIq',
    description: 'Import Button',
  },
  createPurchaseOrderButton: {
    description: 'button label for Create Purchase Order in the Supplier Details Panel',
    defaultMessage: 'Create Purchase Order',
    id: '8dk1Oe',
  },
});
